import { Breadcrumbs } from "@mui/material";
import React from "react";
import ReactRouterLink from "./ReactRouterLink";

interface IProps {
  items: { url: string; text: string }[];
}

export const Breadcrumb: React.FC<IProps> = ({ items }: IProps) => {
  return (
    <nav aria-label="breadcrumb">
      <Breadcrumbs
        separator=">"
        sx={{
          "& ol": {
            justifyContent: "left",
            margin: "auto",
            maxWidth: "1500px",
            marginTop: "10px",
            marginBottom: "10px",
            padding: 0, // Remove any padding
          },
          paddingLeft: 2, // Remove padding on the left
          "@media (max-width: 600px)": {
            // Hide on mobile screens
            display: "none",
          },
        }}
        component="ol"
        itemScope
        itemType="http://schema.org/BreadcrumbList"
      >
        {items.map(
          (item, index) =>
            item.text && (
              <li
                key={index}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
                style={{ display: "inline" }}
              >
                <ReactRouterLink
                  style={{
                    color: "grey",
                    fontSize: "0.9rem", // Smaller font size
                  }}
                  to={item.url}
                  itemProp="item"
                  linkElement={<span itemProp="name">{item.text}</span>}
                  isLinkUnderline={false}
                />
                <meta itemProp="position" content={(index + 1).toString()} />
              </li>
            )
        )}
      </Breadcrumbs>
    </nav>
  );
};
